import { MatSnackBar } from "@angular/material/snack-bar";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";

import {
  CreateChannelOrderPayload,
  GetEstimatedFees,
  SaveItemPayload,
  SaveVendorPayload,
  SetSkuMapPayload,
  updateIgnorePayload,
} from "src/app/models/planyard.model";
import { AgGridRequestService } from "src/app/services/ag-grid-request.service";

import { map, tap, timeout, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { HeaderService } from "./../../components/header/header.service";
import { SnackbarComponent } from '../../components/snackbar/snackbar.component';

@Injectable({
  providedIn: "root",
})
export class PlanyardService implements OnDestroy {
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  options = { headers: this.headers };
  account :string;
  private repricerUrl = "api/Repricer";
  private inventoryUrl = "api/inventory";
  private ordersUrl = "api/orders";
  vendorId: number;
  invalidAsin: any[] =[];
  setFeeMonitorFilter;
  selectedCostSku: any;
  loadFile: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private http: HttpClient,
    private headerService: HeaderService,
    private agGridRequestService: AgGridRequestService,
    private snackBar: MatSnackBar
  ) {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => (this.account = e[0]));
  }

  GetOrdesrList(body, columnDefs, globalSearch?,account?,filterModel?) {
    let filters;
    if(account){
      filters = {
        Account: {
          filterType: "set",
          values: [account],
        },
      } 
    }

    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      filterModel ? filterModel : filters
    );
    return this.http.post(
      `/${this.repricerUrl}/GetOrdersList`,
      payload,
      this.options
    );
  }

  GetOrdersHist(body, columnDefs, skuFilter, FirstStockDayFilter) {
    body.filterModel[skuFilter.field] = {
      filter: skuFilter.filter,
      filterType: "text",
      type: "equals",
    };
    body.filterModel[FirstStockDayFilter.field] = {
      dateFrom: FirstStockDayFilter.filter,
      filterType: "date",
      type: "greaterThanOrEqual",
    };
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      undefined,
      {
        Account: {
          filterType: "set",
          values: [this.account],
        },
      }
    );
    return this.http.post(
      `/${this.repricerUrl}/GetOrdersHist`,
      payload,
      this.options
    );
  }

  getOrdersHistByAsin(body, columnDefs, skuFilter, FirstStockDayFilter,account) {
    body.filterModel[skuFilter.field] = {
      filter: skuFilter.filter,
      filterType: "text",
      type: "equals",
    };
    body.filterModel[FirstStockDayFilter.field] = {
      dateFrom: FirstStockDayFilter.filter,
      filterType: "date",
      type: "greaterThanOrEqual",
    };
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      undefined,
      {
        Account: {
          filterType: "set",
          values: [account ? account : this.account],
        },
      }
    );
    return this.http.post(
      `/${this.repricerUrl}/GetOrdersHistByAsin`,
      payload,
      this.options
    );
  }

  getOrdersHistByAsinFulfillment(body, columnDefs, skuFilter, FirstStockDayFilter,account,FullfillmentType) {
    body.fbm = FullfillmentType
    body.filterModel[skuFilter.field] = {
      filter: skuFilter.filter,
      filterType: "text",
      type: "equals",
    };
    body.filterModel[FirstStockDayFilter.field] = {
      dateFrom: FirstStockDayFilter.filter,
      filterType: "date",
      type: "greaterThanOrEqual",
    };
    
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      undefined,
      {
        Account: {
          filterType: "set",
          values: [account ? account : this.account],
        },
        
      }
    );
    return this.http.post(
      `/${this.repricerUrl}/GetOrdersHistByAsinFulfillment`,
      payload,
      this.options
    );
  }

  SetSkuMapping(payload: SetSkuMapPayload) {
    return this.http.post(
      `/${this.inventoryUrl}/SetSkuMapping`,
      payload,
      this.options
    ).pipe(
      tap(() => {
        this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: 'Successfully saved mapping',
                action: 'Dismiss',
                type: 'success',
              },
            }
        );
      })
    );
  }

  TypeaheadItem(qry: string, VendorId?: number, Type?: string,startRow?:number,endRow?:number) {
    const encodedQuery = encodeURIComponent(qry);
    return this.http.get(
      `/${this.inventoryUrl}/TypeaheadItem?Qry=${encodedQuery}${
        VendorId ? "&VendorId=" + VendorId : ""
      }${Type ? "&Type=" + Type : ""}${
        startRow ? "&StartRow=" + startRow : ""
      }${
        endRow ? "&EndRow=" + endRow : 10
      }`,
      this.options
    );
  }

  GetSkuMappings(accountSkuId: number) {
    return this.http.get(
      `/${this.inventoryUrl}/GetSkuMappings?AccountSkuId=${accountSkuId}`,
      this.options
    );
  }

  GetItemsList(body, columnDefs, globalSearch?) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch
    );
    return this.http.post(`/api/Repricer/GetItemList`, payload, this.options);
  }

  SaveItem(payload: SaveItemPayload) {
    return this.http.post(
      `/${this.inventoryUrl}/SaveItem`,
      payload,
      this.options
    );
  }

  GetVendorList(body, columnDefs, globalSearch?) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch
    );
    return this.http.post(
      `/${this.inventoryUrl}/GetVendorList`,
      payload,
      this.options
    );
  }

  VendorExists(name) {
    return this.http.post(
      `/${this.inventoryUrl}/VendorExists`,
      { name },
      this.options
    );
  }

  VendorItemExists(name, vendorID,itemVendorId) {
    return this.http.post(
      `/${this.inventoryUrl}/VendorItemExists`,
      { name, vendorID ,itemVendorId},
      this.options
    );
  }

  ProductExists(name) {
    return this.http.post(
      `/${this.inventoryUrl}/ProductExists`,
      { name },
      this.options
    );
  }

  GetPoPlan(planId) {
    return this.http.post(
      `/${this.inventoryUrl}/SaveItem`,
      { planId },
      this.options
    );
  }

  SaveVendor(saveVendorPayload: SaveVendorPayload) {
    return this.http.post(
      `/${this.inventoryUrl}/SaveVendor`,
      saveVendorPayload,
      this.options
    );
  }

  GetProductsList(body, columnDefs, globalSearch?) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch
    );
    payload.vendorId = this.vendorId;
    return this.http.post(
      `/api/Repricer/GetProductList`,
      payload,
      this.options
    );
  }

  GetProductMappings(ProductId, IsForecasting = false) {
    return this.http
      .get(
        `/${this.inventoryUrl}/GetProductMappings?ProductId=${ProductId}&IsForecasting=${IsForecasting}`,
        this.options
      )
      .pipe(
        map((items: any[]) => {
          return items.map((item) => {
            item["ProductId"] = ProductId;
            return item;
          });
        })
      );
  }

  GetProductsOrderList(body,columnDefs, AccountSkuIds?) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      "",
      {
        AccountSkuId: {
          filterType: "number",
          type: "in",
          intValues: AccountSkuIds.length ? AccountSkuIds : [],
        },
      }
    );
    return this.http.post(`api/Repricer/GetOrdersList`, payload, this.options);
  }

  GetProductsItemsList(body,columnDefs, filters?) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      "",
      filters
    );
    return this.http.post(`/api/Repricer/GetItemList`, payload, this.options);
  }

  GetProductDetails(id: number) {
    return this.http.get(
      `/${this.inventoryUrl}/GetProductDetails?id=${id}`,
      this.options
    );
  }

  GetInventoryTransationList(body, columnDefs, ProductId?) {
    const filterModel = {
      ProductId: {
        filterType: "number",
        type: "equals",
        filter: ProductId,
      },
    };

    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      "",
      filterModel
    );

    return this.http.post(
      `/${this.inventoryUrl}/GetInventoryTransationList`,
      payload,
      this.options
    );
  }

  CreateChannelOrder(payload: CreateChannelOrderPayload) {
    return this.http.post(
      `/${this.ordersUrl}/CreateChannelOrder`,
      payload,
      this.options
    );
  }

  GlobalSkuTypeahead(payload) {
    return this.http.post(
      `/${this.ordersUrl}/GlobalSkuTypeahead`,
      {qry: payload},
      this.options
    );
  }

  AddChannelSku(sku: string, imageUrl: string, price: number, title: string) {
    return this.http.post(
      `/${this.ordersUrl}/AddChannelSku`,
      { sku, imageUrl, price, title },
      this.options
    );
  }

  UpdateOrderStatus(orderId: string, status: string) {
    return this.http.post(
      `/${this.ordersUrl}/UpdateOrderStatus`,
      { orderId, status },
      this.options
    );
  }

  GetInventoryTransationListNew(body, columnDefs, ProductId?) {
    const filterModel = {
      ProductId: {
        filterType: "number",
        type: "equals",
        filter: ProductId
      }
    }

    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      "",
      filterModel
    );

    return this.http.post(
      `/${this.inventoryUrl}/GetInventoryTransationListNew`,
      payload,
      this.options
    );
  }

  GetProductListExport(filters, columns, globalSearch,isExport?) {
    const body = {
      filterModel: filters,
      sortModel:  [{sort: "desc", colId: "Restock"}]
     
    };
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columns,
      globalSearch,
      null,
      null,
      isExport
    );
    payload.loadAll=true;

    return this.http.post(`/${this.repricerUrl}/GetProductListExport`, payload, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }

  GetOrdersVendorList(body,columnDefs,filter) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      "",
      filter
    );
    return this.http.post(`api/Repricer/GetOrdersVendorList`, payload, this.options);
  }

  UpdateOrderQtyPrice(payload) {
    return this.http.post(
      `/${this.repricerUrl}/UpdateOrderQtyPrice`,payload,this.options
    );
  }
  
  GetsalesOrdersList(body, columnDefs, globalSearch?,account?) {
    let filters = {
      Account: {
        filterType: "set",
        values: [account ? account : this.account],
      },
    };

    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      filters
    );
    return this.http.post(
      `/${this.repricerUrl}/GetsalesList`,
      payload,
      this.options
    );
  }

  GetFeesMonitorReport(body, columnDefs, globalSearch?) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch
    );
    return this.http.post(
      `/${this.repricerUrl}/GetFeesMonitorReport`,
      payload,
      this.options
    );
  }
  
  getCustomCost(accountSkuId) {
    return this.http.get(
      `/${this.repricerUrl}/GetCustomCost?AccountSkuId=${accountSkuId}`,
      this.options)
  }

   saveCost(payload) {
    return this.http.post(
      `/${this.repricerUrl}/AddUpdateCustomCost`,
      payload,
      this.options
    );
  }
  
  vendorOrderList(body, columnDefs, globalSearch?) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
    );
    return this.http.post(
      `/${this.repricerUrl}/VendorOrderList`,
      payload,
      this.options
    );
  }

   deleteCost(customCostId) {
    return this.http.post(
      `/${this.repricerUrl}/DeleteCustomCost`,
      customCostId,
      this.options
      );
    }

  getOrderByVendor(body, columnDefs, globalSearch?,datefrom?,dateto?,vendorName?) {
    let filters = {};
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      "",
      filters
    );
    payload.dateFrom=datefrom;
    payload.dateTo=dateto;
    payload.vendorName = vendorName
    return this.http.post(
      `/${this.repricerUrl}/GetOrderByVendor`,
      payload,
      this.options
    );
  }


  
  GetEstimatedFees(payload) {
    return this.http.post(
      `/${this.repricerUrl}/GetEstimateFees`,payload,this.options
    ).pipe(timeout(100000));
  }

  GetCatlogByAsin(payload) {
    return this.http.post(
      `/${this.repricerUrl}/GetCatlogByAsin`,payload,this.options
    );
  }

  GetPriceOfferByAsin(payload) {
    return this.http.post(
      `/${this.repricerUrl}/GetPriceOfferByAsin`,payload,this.options
    );
  }

  public exportExcelFile(){
    return  this.http.get(`../../../../../assets/Excel/bulk-import-template.xlsx`,{ responseType: 'blob' })
  }
  
  UpdateShipmentIgnore(payload:updateIgnorePayload){
    return this.http.post(
      `/${this.repricerUrl}/UpdateShipmentIgnore`,
      payload,
      this.options
    );
  }

  GetReferealFees(payload) {
    return this.http.post(
      `/${this.repricerUrl}/GetReferealFees`,payload,this.options
    );
  }
  getCountDays(){
    return this.http.get(`/${this.repricerUrl}/GetIgnoredOrderDaysCount`, this.options)
  }

  GetIgnoredOrderDays(){
    return this.http.get(`/${this.repricerUrl}/GetIgnoredOrderDays`, this.options)
  }

  saveIgnoreOrderDays(payload){
    return this.http.post(`/${this.repricerUrl}/SaveIgnoredOrderDays`,payload, this.options)
  }

  SyncEnabled(paylaod){
    return this.http.post(`/${this.repricerUrl}/SyncEnabled`,paylaod, this.options)
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  skuItemDetail(payload){
    return this.http.post(`/${this.repricerUrl}/SkuItemDetail`,payload, this.options)
  }

  InventoryUpdateBySku(payload){
    return this.http.post(`/${this.repricerUrl}/InventoryUpdateBySku`,payload, this.options)
  }
}
